// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__jbISQ","head":"styles_head__RVpG0","buttonGroup":"styles_buttonGroup__AbwJ3","button":"styles_button__zg5Yn","buttonTabs":"styles_buttonTabs__5c0eB"};